import load from 'simple-load-script';
import { validate } from './bridgeSchema';

export default mock => async ({ mockUrl }) => {
  try {
    validate(mock());
  } catch (e) {
    if (mockUrl) {
      await load(mockUrl);
    }
  }

  return mock();
};



// WEBPACK FOOTER //
// ./src/Bridge/mockResolver.js